import { useEffect, useRef } from 'react';
import { useDropdownMenu } from 'react-overlays';
import { DropDownListCombinedProps } from './types';

// MANUAL OVERRIDE
const usePresenter = (props: DropDownListCombinedProps): DropDownListCombinedProps => {
  const { onDropdownToggle, preventDropdownClosing, ...otherProps } = props;
  const inputRef = useRef<HTMLInputElement>(null);

  const [menuProps, { toggle, show }] = useDropdownMenu({
    flip: true,
    offset: props.offset || [0, 0],
  });

  useEffect(() => {
    onDropdownToggle?.(show);
  }, [show]);

  const items = props.dropDownItems?.map((item) => {
    return {
      ...item,
      onClick: (event) => {
        event.preventDefault();
        if (toggle && !preventDropdownClosing) {
          toggle(false);
        }
        if (item.onClick) {
          item.onClick(event);
        }
      },
    };
  });

  useEffect(() => {
    if (show && inputRef.current) {
      inputRef.current.focus();
    }
  }, [show]);

  return {
    ...otherProps,
    inputRef,
    ...menuProps,
    dropDownItems: items,
    role: 'menu',
  };
};

export default usePresenter;
